import React, { useState } from 'react'
import { Input, FormCustom } from '../../Components/Form/Form'

const ClasificationForm = ({ data, onSubmit, disablebSubmit, loadSubmit }) => {
    const [row, setRow] = useState({
        p_id_clasification: data.id_clasification,
        p_name_clasification: data.name_clasification,
        p_code_clasification: data.code_clasification
    })

    return <FormCustom dataSubmit={row} onSubmit={onSubmit} disablebSubmit={disablebSubmit} loadSubmit={loadSubmit}>
        <Input
            text="Descripción"
            placeholder="Descripción"
            classNameParent="col-12 mb-2"
            icon="far fa-comment-alt"
            required
            invalid="El campo es obligatorio."
            defaultValue={data.name_clasification}
            onChange={e => setRow({ ...row, p_name_clasification: e.currentTarget.value })}
            maxLength={150}
        />
        <Input
            text="Código"
            placeholder="Código"
            classNameParent="col-12 mb-2"
            icon="fas fa-code"
            required
            invalid="Formato incorrecto. Ej: KG, CAJA"
            defaultValue={data.code_clasification}
            onChange={e => setRow({ ...row, p_code_clasification: e.currentTarget.value })}
            maxLength={20}
        />
    </FormCustom>
}

ClasificationForm.defaultProps = {
    data: {
        id_clasification: '',
        name_clasification: '',
        code_clasification: ''
    },
    onSubmit: () => {},
    loadSubmit: false
}

export default ClasificationForm;